import { Reveal, Eyebrow } from "@/components/primitives";

const MARQUES = [
  { title: "German Engineering", sub: "Precision-built performance marques" },
  { title: "Swedish Craftsmanship", sub: "Safety-led Scandinavian luxury" },
  { title: "American Capability", sub: "Rugged premium SUVs" },
];

export default function Brands() {
  return (
    <section
      id="brands"
      data-testid="brands-section"
      className="bg-walnut py-20 sm:py-28"
    >
      <div className="mx-auto max-w-7xl px-6 sm:px-10">
        <Reveal>
          <Eyebrow index="04">Multi-Brand Expertise</Eyebrow>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 max-w-xl font-display text-3xl font-extrabold uppercase leading-tight tracking-tight text-ivory sm:text-4xl lg:text-5xl">
            Premium <span className="gold-text">Multi-Brand</span> Service
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-4 max-w-md text-sm font-light leading-relaxed text-ivory/60 sm:text-base">
            Specialised care for the world's most distinguished automobiles.
          </p>
        </Reveal>

        <div data-testid="marque-manifesto" className="mt-14">
          {MARQUES.map((m, i) => (
            <Reveal key={m.title} delay={0.15 + i * 0.12} y={44}>
              <div
                data-testid={`marque-line-${i + 1}`}
                className="flex flex-col gap-2 border-t border-gold/15 py-7 sm:flex-row sm:items-baseline sm:justify-between sm:gap-6"
              >
                <span className="font-display text-2xl font-extrabold uppercase tracking-tight text-ivory sm:text-4xl">
                  {m.title}
                </span>
                <span className="text-[10px] font-semibold uppercase tracking-[0.25em] text-ivory/40 sm:shrink-0 sm:text-right sm:text-xs">
                  {m.sub}
                </span>
              </div>
            </Reveal>
          ))}
          <Reveal delay={0.55} y={44}>
            <div className="border-t border-gold/15 py-7">
              <span className="gold-text font-display text-2xl font-extrabold uppercase tracking-tight sm:text-4xl">
                Seven Marques. One Standard.
              </span>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
